module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("One")])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("CLEARING THE WAY")]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633151_i0003.jpg",
      "src": "images/e9781439633151_i0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Settling this new territory, later named Hassan Township, was a daunting task. The land resided in the northwesternmost corner of Hennepin County in Minnesota and was laden with trees. The only access to the heavily wooded area was by water via steamboat on the Mississippi River or by small boat along the Crow River. In 1854, Alexander Borthwick and Harvey Hicks are said to have brought the first horses and wagon into the area, cutting a road through the timber. Dennis Ford, Alpheus Maservy, and Joseph Green followed that fall. In April 1855, Henry Parslow and Jasper Hawkins penetrated the “Big Woods” for their oxen-drawn wagon to pass. Other early pioneers were Tomas Rogers; Mortimer and Patrick Hynes; Horatio “Happy” Hawkins; Septimus, John, and Charles Parslow; Henry Ghostley; John Mitchell; Samuel Gowell; John Keegan; Patrick Burke; Owen McCabe; Ariel Begelow; A. Woodman; Harvey Norton; Charles Tucker; and William Demery. The government price for land was $1.25 per acre. (Courtesy of Jack and Peggy Dahlheimer.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "88%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633151_i0004.jpg",
      "src": "images/e9781439633151_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The territorial legislature, in 1855, accelerated access to the area when George B. Wright surveyed Territorial Road, the first public road to pass through Hassan Township; it was also known as the Minneapolis and Monticello Road and crosses the highest point in Hennepin County. In 1856, Harvey S. Norton hired Wright to survey a town site on the Crow River in northwestern Hennepin County. Norton named this site Hassan, for the Dakota word "), _c('em', {
    staticClass: "i"
  }, [_vm._v("chanhasan")]), _vm._v(", meaning “the sugar maple tree.” Hassan has remained primarily rural to this day and has the distinct honor of being the last township in Hennepin County. (Courtesy of Jack and Peggy Dahlheimer.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "88%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633151_i0005.jpg",
      "src": "images/e9781439633151_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Hassan established a post office at Hassan Rapids on February 11, 1857. The first mail was delivered to Septimus Parslow’s home on July 4, 1856, by horseback. The post office discontinued service on March 25, 1859. The Rogers Post Office was established on November 17, 1884, with the first postmaster being Daniel Hawkins. The trade center of Walburga also wanted a post office. The community lobbied United States congressman Loren Fletcher to assist them with this request. Local community members say that he agreed to support their cause as long as they named the post office after him. The original post office application states the town name as Walburg and the post office name was to be Fletcher. The post office was appointed on June 28, 1900. The first postmaster was Andrew N. Nelles, and John Stenglein was the final postmaster when the post office closed August 31, 1906; mail was forwarded to Rogers. (Courtesy of Jack and Carol Hines.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "61%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633151_i0006.jpg",
      "src": "images/e9781439633151_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("On April 3, 1860, the community of Hassan Township elected the first city council officers. The results were as follows: chairman, Gideon Reeves; supervisors, Harvey Hickes and Richard Quinn; town clerk, C. J. Parslow; treasurer, L. Parslow; assessor, A. Borthwick; justice of the peace, Henry Ghostley; constables, Patrick Hynes and John Parslow. This 1915 copy of the Farmers Directory of Hassan Township reflects the families owning land within Hassan Township. It includes the location of their land, how many acres they owned, to whom they were married, the names of their children, and how long they had lived in the county. While interviewing Carol (Berg) Hines, she shared that although she was a Berg, her dad’s mother was a Dahlheimer and mother’s dad was a Scharber; therefore, if the Hines family had not come from Ireland she could not imagine who she could have married. (Courtesy of Jack and Carol Hines.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "88%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633151_i0007.jpg",
      "src": "images/e9781439633151_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The legal description from a copy of the original purchase agreement between Thomas Rogers Jr. and Gustaves A. Austin on July 24, 1880, reflects that Thomas Rogers Jr. and his wife, Maggie, acquired the original land that became known as Rogers Siding. The sum of this transaction was $2,000. A copy of another agreement between Thomas and Maggie to sell about one acre of land for $200 to the St. Paul, Minneapolis and Manitoba Railway Company transpired on April 29, 1887. These original documents were provided by descendant Jim Rogers, which could explain how the area became known as Rogers Siding. However, some locals speculate the area was named after famous American surveyor Maj. A. B. Rogers who worked for James J. Hill. Major Rogers was known for finding a rail route through the Selkirk and Rocky Mountains in British Columbia, Canada. (Courtesy of Leo Scharber.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633151_i0008.jpg",
      "src": "images/e9781439633151_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Almost one hundred years after the first pioneers began claiming land in Hassan Township, the North Hennepin Post chose to remember these adventurers. The Hassan country school was the first school in the area, with Sarah Ward teaching students in 1857, followed the next year by Helen Tilton. Pictured in this article is George Sebastian; there is speculation whether his last name was spelled Scherber or Scharber, and some believe it may have been Schirber in his home country of Germany. Regardless, it has been determined the family name has changed many times. This entrepreneur created a general merchandise store in 1892 that became a cornerstone for the community and a legacy for his family. The Modern Woodman of America built a hall just across the road from the Episcopal church in 1902. The building was used for lodge meetings and as a community center for social activities; it was torn down in the late 1930s. (Courtesy of Crow River News.)")])])])])])]), _c('a', {
    attrs: {
      "id": "title3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06218ea8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439633151_c01.vue
// module id = 78
// module chunks = 0